
import {AiFillGithub} from 'react-icons/ai'
import {FaLinkedinIn} from 'react-icons/fa'
import {IoLogoFacebook} from 'react-icons/io'
import {IoLogoTwitter} from 'react-icons/io'



export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#services', title: 'Services'},
    {id: 4, link: '#portfolio', title: 'Portfolio'},
    {id: 5, link: '#contact', title: 'Contact'}
]


export const socials = [    
    {id: 1, link: 'https://www.linkedin.com/in/donald-madangure-314838ba', icon: <FaLinkedinIn />},
    {id: 2, link: 'https://twitter.com', icon: <IoLogoTwitter />},
    {id: 2, link: 'https://www.facebook.com', icon: <IoLogoFacebook/>},
    {id: 4, link: 'https://github.com/donald-madangure', icon: <AiFillGithub/>},    
]